import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function HowItWorks() {
  const steps = [{
    number: '01',
    title: 'Prepárate',
    description: 'Descarga el material y escucha el audio de 5 minutos para calibrar tu propia respuesta nerviosa.'
  }, {
    number: '02',
    title: 'Aplica',
    description: "Aplica el descenso físico y el script de validación la próxima vez que el 'humo' aparezca."
  }, {
    number: '03',
    title: 'Conecta',
    description: 'Recupera la conexión con tu hijo y sal de la situación con dignidad y paz.'
  }];
  return <section className="py-24 bg-white" data-id="element-96">
      <div className="max-w-5xl mx-auto px-6 lg:px-8" data-id="element-97">
        <FadeIn data-id="element-98">
          <div className="text-center mb-20" data-id="element-99">
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-100">
              ¿Cómo funciona?
            </h2>
            <p className="text-xl text-charcoal-light" data-id="element-101">
              Tres pasos simples para transformar el caos en calma.
            </p>
          </div>
        </FadeIn>

        <div className="relative" data-id="element-102">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-0 w-full h-0.5 bg-sage-100 -z-10" data-id="element-103"></div>

          <div className="grid md:grid-cols-3 gap-12 md:gap-8" data-id="element-104">
            {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} data-id="element-105">
                <div className="relative flex flex-col items-center text-center" data-id="element-106">
                  <div className="w-24 h-24 rounded-full bg-white border-4 border-sage-100 flex items-center justify-center mb-6 shadow-sm" data-id="element-107">
                    <span className="text-3xl font-serif font-bold text-sage-500" data-id="element-108">
                      {step.number}
                    </span>
                  </div>
                  <h3 className="text-2xl font-bold mb-4 text-charcoal" data-id="element-109">
                    {step.title}
                  </h3>
                  <p className="text-charcoal-light leading-relaxed" data-id="element-110">
                    {step.description}
                  </p>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}